module.exports = __webpack_public_path__ + "media/honey-icons/icon-quick-actions-e1c985a8.svg";